import { Card, Form, Row, Col, Button, notification } from "antd";
import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import _ from 'lodash';
import Request, { API_URL, LAPI_URL } from "../../../request";
import async from 'async';

@Form.create()
class EmailCampaign extends React.Component {
    state = {
        emailType:'',
        toEmail:''
    }


    componentDidMount() {
        
    }


    handleSubmit = (e) =>{
        e.preventDefault();
        let {form} = this.props
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData);
            let response = await Request.addEmailCampaign(values);
            if(response.success) {
                notification.success({
                    message:response.message
                })
            }else {
                notification.error({
                    message:response.message
                })
            }
            this.setState({emailType:''}, ()=>{
                form.resetFields();
            })
        })
    }

    render() {
        let {form:{getFieldDecorator, setFieldsValue}} = this.props;
        let {emailType} = this.state;
        const inputTypes = {
            fields:[
                {
                    label:'Campaign Name',
                    key:'campaignName',
                    required:true
                },
                {
                    label:'Email Type',
                    key:'emailType',
                    type:'select',
                    required:true,
                    options:['Branch', 'University'],
                    onChange:v=>{
                        this.setState({emailType:v}, () =>{
                            setFieldsValue({emailType:v})
                        })
                        
                    }
                },
                {
                    label:'To Email',
                    key:'toEmail',
                    type:'select',
                    required:true,
                    hidden:this.state.emailType === ""?true:false,
                    options:[{id:`active`, display:`Bulk Emails To Active ${emailType}`},
                        {id:`custom`, display:`Custom - Emails to Any Recipient`},
                        {id:`all`, display:`Bulk Emails to All ${emailType}`},
                        {id:`excel`, display:`Excel Data - Bulk Email to New ${emailType}`}
                    ],
                    onChange:v=>{
                        this.setState({toEmail:v}, () =>{
                            setFieldsValue({toEmail:v});
                        })
                        
                    }
                },
                {
                    label:'Receipient Emails (Separated By ",")',
                    key:'emailIds',
                    required:this.state.toEmail === "custom"?true:false,
                    hidden:this.state.toEmail !== "custom"?true:false
                },
                {
                    label:'Upload Excel',
                    key:'emailFile',
                    type:'file',
                    required:this.state.toEmail === "excel"?true:false,
                    hidden:this.state.toEmail !== "excel"?true:false,
                    prefixComp:<small>Download Sample File <a href={`${API_URL}/media/email-campaign-sample.csv`}>Here</a></small>
                },
                {
                    label:'Reply To',
                    key:'replyTo',
                },
                {
                    label:'Email Subject',
                    required:true,
                    key:'emailSubject'
                },
                {
                    label:'Template',
                    required:true,
                    key:'emailBody',
                    type:'editor'
                }
            ]
        }
        return (
            <PageHeaderWrapper title="Email Campaign">
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields apiurl={LAPI_URL} getFieldDecorator={getFieldDecorator} inputSchema={inputTypes} />
                        <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                    </Form>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmailCampaign)
